import { globalTheme } from 'styles/global-theme';

export const filterStyles = {
  container: {
    padding: `${globalTheme.space[0]}`,
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: `${globalTheme.space[0]}`,
  },
  text: {
    color: 'white',
    fontSize: '18px',
  },
  input: {
    padding: `${globalTheme.space[0]}`,
    width: '100%',
    borderRadius: '6px',
    outline: 'none',
    border: '1px solid',
  },
  dateInput: {
    padding: `${globalTheme.space[0]}`,
  },
};
